// :: This Object creates a basic interface for ago-web-worker ::
// - To rebuild: npm run build:interface (from the root of the project directory)
export default {

  /* Public
   * args (Object, function)
   * - The object expects the following parameters:
   *   clientId, orgUrlKey, environment (devext, qa, production) if set to null, this will default to production
   * - The function is a callback function (must be bound to your context with arrow function or bind method)
   * returns agoWebWorker
  */
  init: function (data, callback) {
    if (!data.clientId) return;
    window.addEventListener("message", this._handleJsonMessage.bind(this));

    this.userData = data;
    this.userData.homeAppOrigin = this._getHomeAppOrigin(this.userData.orgUrlKey, this.userData.environment, this.userData.portal) + "pages/ago_web_worker.html#";
    this.userData.iframe = this.createIframe(this.userData.homeAppOrigin, this.userData.orgUrlKey, this.userData.environment);
    this.currentClientCallback = callback;

    this.resources = data.resources || null;
    this.portalConnectionEstablished = false;
    this.portal = this._readyPortalForTransport(data.portal, data.orgUrlKey);
    this.portalUser = this._readyPortalUserForTransport(data.portalUser);
    return this;
  },

  _handleJsonMessage: function (response, o) {
    try {
      var data = JSON.parse(response.data);
    } catch (e) {
      return this.currentClientCallback({success: false, error: e});
    }
    return this.currentClientCallback(data);
  },

  /* Public
   * args (String, String, Object or null, function)
  */
  performAction: function (module, action, data, callback) {
    if (!this.portalConnectionEstablished) {
      data = data || {};
      if (this.resources) data.resources = this.resources;
      data.portal = this.portal;
      data.portalUser = this.portalUser;
      this.portalConnectionEstablished = true;
    }
    this.currentClientCallback = callback;
    this.requestResource(module, action, typeof data === "string" ? data : JSON.stringify(data));
  },

  _getHomeAppOrigin: function (urlKey, env, portal) {
    if(portal.isPortal){
      return portal.url + "/home/";
    }
    var protocol = location.protocol;
    if (env && (env === "devext" || env === "qa")) {
      if (urlKey) {
        return protocol + "//" + (urlKey || "") + ".maps" + env + ".arcgis.com/home/";
      } else {
        return protocol + "//" + (env === "devext" ? env : "qaext") + ".arcgis.com/home/";
      }
    } else {
      return protocol + "//" + (urlKey ? urlKey + ".maps." : "") + "arcgis.com/home/";
    }
  },

  _getOriginOfUrl: function (url) {
    url = url || window.location;
    return url.protocol + "//" + url.hostname + (url.port ? ":" + url.port : "");
  },

  _readyPortalForTransport: function (portal, urlKey) {
    return {
      urlKey: urlKey,
      portalUrl: portal.portalUrl,
      customBaseUrl: portal.customBaseUrl,
      allSLL: portal.allSSL,
      isPortal: portal.isPortal,
      httpPort: portal.httpPort,
      httpsPort: portal.httpsPort,
      allowedBetaFeatures: portal.allowedBetaFeatures,
      portalHostname: portal.portalHostname,
      portalProperties: this._getEnabledProperties(portal.portalProperties, [
        "openData"
      ]),
      subscriptionInfo: this._getEnabledProperties(portal.subscriptionInfo, [
        "hubSettings"
      ]),
      helperServices: this._getBooleanProperties(portal.helperServices, [
        "rasterAnalytics",
        "orthoMapping",
        "locationTracking"
      ])
    };
  },

  _getEnabledProperties: function (obj, properties) {
    var enabledProps = {};
    if(obj){
      properties.forEach(function (prop) {
        if (obj[prop]) {
          enabledProps[prop] = {enabled: obj[prop].enabled}
        }
      });
    }
    return enabledProps;
  },

  _getBooleanProperties: function (obj, properties) {
    var props = {};
    if(obj){
      properties.forEach(function (prop) {
        if (obj[prop]) {
          props[prop] = true;
        }
      });
    }
    return props;
  },

  _readyPortalUserForTransport: function (user) {
    return {
      username: user.username,
      credential: {
        token: user.credential.token
      },
      orgId: user.orgId,
      role: user.role,
      privileges: user.privileges,
      isOrgAdmin: user.isOrgAdmin,
      userLicenseTypeId: user.userLicenseTypeId
    };
  },

  createIframe: function (url, orgUrlKey, environment) {
    url += "origin=" + this._getOriginOfUrl();
    url += "&clientId=" + this.userData.clientId;
    return this._create("iframe", {
      "src": url,
      "style": "display:none;"
    }, document.body);
  },

  _create: function (el, attributes, parent) {
    if (typeof el !== "string") {
      throw "Error in _create: element must be a string";
    } else {
      var newElement = document.createElement(el);
    }
    if (typeof attributes !== "object" || Array.isArray(attributes)) {
      throw "Error in _create: attributes must be defined in an object";
    } else if (attributes !== null) {
      Object.keys(attributes).forEach(function (name) {
        if (name === "innerHTML") { newElement.innerHTML = attributes[name]; }
        else { newElement.setAttribute(name, attributes[name]); }
      });
    }
    if (parent !== null && parent !== undefined) {
      parent.appendChild(newElement);
    }
    return newElement;
  },

  _addEvent: function (el, type, handler) {
    if (el.attachEvent) el.attachEvent("on" + type, handler); else el.addEventListener(type, handler);
  },

  requestResource: function (resourceName, resourceAction, resourceData) {
    this.userData.iframe.contentWindow.postMessage({
      name: resourceName,
      action: resourceAction,
      data: resourceData
    }, this.userData.homeAppOrigin);
  }
};
